var _defs, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartpayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 150,
    viewBox: "0 0 540 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoPurple",
    x1: 7,
    y1: 18,
    x2: 125,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A99DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6753E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoTeal",
    x1: 30,
    y1: 65,
    x2: 139,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BE3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A90"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 53 64 16c8-6 19-6 27 0l32 22-23 17-26-18-40 28 18 13-24 17-18-13c-10-7-10-22 0-29Z",
    fill: "url(#logoPurple)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m137 97-54 37c-8 6-19 6-27 0l-32-22 23-17 26 18 40-28-18-13 24-17 18 13c10 7 10 22 0 29Z",
    fill: "url(#logoTeal)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 99,
    fontFamily: "Manrope, Inter, Segoe UI, sans-serif",
    fontSize: 70,
    fontWeight: 800,
    letterSpacing: -4.4,
    fill: "#6753E7"
  }, "smart", /*#__PURE__*/React.createElement("tspan", {
    fill: "#00A99D"
  }, "pay"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartpayLogo);
export default __webpack_public_path__ + "static/media/smartpay-logo.65772b6532097e8aa0a500f38b5ba4fd.svg";
export { ForwardRef as ReactComponent };